'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useParams } from 'next/navigation';
import { SEARCH_PARAM_KEYS } from '@/constants/auth';
import { useAuthContext } from '@/context/AuthContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useUAContext } from '@/context/UAContext';
import { useVSCSdkContext } from '@/context/VSCSdkContext';
import { buildShareComponentOriginConfig } from '@/lib/share-component';
import type { AuthConfig, Device, LocaleConfig, OriginConfig } from '@viveportengineering/share-component';
type UseShareComponentBaseConfigOptions = {
  previewMode?: boolean;
  profile: AuthConfig['profile'];
};
type ShareComponentBaseConfig = {
  authConfig: AuthConfig;
  device: Device;
  localeConfig: LocaleConfig;
  originConfig: OriginConfig;
};
export function useShareComponentBaseConfig(t0) {
  const $ = _c(17);
  const {
    previewMode: t1,
    profile
  } = t0;
  const previewMode = t1 === undefined ? false : t1;
  const params = useParams();
  const locale = useLocale();
  const derivedLocale = params.locale ?? locale;
  const {
    handleLogin,
    handleLogout
  } = useAuthContext();
  const {
    appConfig
  } = useConfigsContext();
  const {
    deviceTypeWithAndroidAndIOS
  } = useUAContext();
  const {
    changeLocale
  } = useVSCSdkContext();
  let t2;
  if ($[0] !== handleLogin || $[1] !== previewMode) {
    t2 = t3 => {
      const callback = t3 === undefined ? "" : t3;
      handleLogin({
        callback,
        loginParams: previewMode ? {
          [SEARCH_PARAM_KEYS.PREVIEW]: ""
        } : undefined
      });
    };
    $[0] = handleLogin;
    $[1] = previewMode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleLogout || $[4] !== profile || $[5] !== t2) {
    t3 = {
      onLogin: t2,
      onLogout: handleLogout,
      profile
    };
    $[3] = handleLogout;
    $[4] = profile;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const authConfig = t3;
  let t4;
  if ($[7] !== changeLocale || $[8] !== derivedLocale) {
    t4 = {
      changeLocale,
      locale: derivedLocale
    };
    $[7] = changeLocale;
    $[8] = derivedLocale;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const localeConfig = t4;
  const t5 = appConfig?.links;
  let t6;
  if ($[10] !== t5) {
    t6 = buildShareComponentOriginConfig(t5);
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== authConfig || $[13] !== deviceTypeWithAndroidAndIOS || $[14] !== localeConfig || $[15] !== t6) {
    t7 = {
      authConfig,
      device: deviceTypeWithAndroidAndIOS,
      localeConfig,
      originConfig: t6
    };
    $[12] = authConfig;
    $[13] = deviceTypeWithAndroidAndIOS;
    $[14] = localeConfig;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}